import React from 'react';
import px from 'prop-types';
import { useSelector } from 'react-redux';
import { compare } from '~features';
import { useAction } from 'Common/hooks';
import { CatalogCompareTray as CompareTray } from 'Common/components/catalog';

export default function CatalogCompareTray({ comparePageUrl }) {
    const compareList = useSelector(compare.selectors.getCompareItems);
    const isLoading = useSelector(compare.selectors.getLoading);

    const onGetCompareList = useAction(compare.actions.getCompareList);
    const onRemoveFromCompareList = useAction(compare.actions.removeFromCompareList);
    const onClearCompareList = useAction(compare.actions.clearCompareList);

    React.useEffect(() => {
        onGetCompareList();
    }, [onGetCompareList]);

    return (
        <CompareTray
            items={compareList}
            isLoading={isLoading}
            comparePageUrl={comparePageUrl}
            onRemoveFromCompareList={onRemoveFromCompareList}
            onClearCompareList={onClearCompareList}
        />
    );
}

CatalogCompareTray.propTypes = {
    comparePageUrl: px.string.isRequired,
};
